var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 177.65 227.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:url(#linear-gradient);}.cls-12,.cls-3{fill:#dedfe0;}.cls-4{fill:#c6c6c6;}.cls-5{fill:#e8e8e8;}.cls-6{isolation:isolate;}.cls-7{fill:#b5b5b5;}.cls-8{fill:#969696;}.cls-9{clip-path:url(#clip-path);}.cls-10{fill:#ffcb39;}.cls-11,.cls-26{fill:#fff;}.cls-11{mix-blend-mode:soft-light;}.cls-12{mix-blend-mode:multiply;}.cls-13{clip-path:url(#clip-path-2);}.cls-14{fill:#5208bc;}.cls-15{fill:#d3d3d3;}.cls-16{fill:url(#linear-gradient-3);}.cls-17{fill:#fcfcfc;}.cls-18{clip-path:url(#clip-path-3);}.cls-19{fill:#c4c4c4;}.cls-20{fill:#adadad;}.cls-21{clip-path:url(#clip-path-4);}.cls-22{clip-path:url(#clip-path-5);}.cls-23{fill:#b2b2b2;}.cls-24{clip-path:url(#clip-path-6);}.cls-25{clip-path:url(#clip-path-7);}.cls-27{fill:#7f1bbf;}.cls-28{fill:url(#linear-gradient-4);}.cls-29{fill:#d8d8d8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -49.41,
    y1: 199.04,
    x2: -35.42,
    y2: 199.04,
    gradientTransform: "translate(102.6 -105.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e23cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4619bf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.52,141l-.74.43a1,1,0,0,0-.31,1.48c3.75,5,15.52,28.93,19,36.07a2.4,2.4,0,0,1-1,3.14l-17.6,10.18a2.41,2.41,0,0,1-2.84-.31c-2.49-2.3-8.3-7.8-15.37-15.5-9.49-10.32-20.91-30.07-24.92-40s-4-10-5.95-19.4c-4.48,5.71-3.15,19.09-2.79,22.06a2.17,2.17,0,0,0,.42,1.05c1.48,2,7.26,9.65,8.58,11.94,1.52,2.63,0,4.7-1.11,4.16A86.32,86.32,0,0,1,50,151a1.52,1.52,0,0,0-1.43-.22c-1.78.7,1.08,3.23,1.08,3.23a47.17,47.17,0,0,0,5.68,3.74,3.72,3.72,0,0,1,2.05,2.61,2.31,2.31,0,0,1-.68,2.32c-3.69,3.32-9.35,1.69-12.48.38a8.71,8.71,0,0,1-4-3.3,19,19,0,0,1-3.09-9.08,18.73,18.73,0,0,0-2.7-10.74c-14.13-27.08,3.31-51.12,4.86-55.66,9-3.18,15.13-10.62,22.07-14.56l-.21.12C68.07,65.77,76.72,63.65,84,57.4c4.71.93,35.09-1.66,51.52,24.1a18.73,18.73,0,0,0,8,7.69,19,19,0,0,1,6.33,7.21,8.71,8.71,0,0,1,.89,5.07c-.43,3.36-1.84,9.08-6.55,10.62a2.31,2.31,0,0,1-2.35-.57,3.72,3.72,0,0,1-1.24-3.08,47.17,47.17,0,0,0-.41-6.79s-.76-3.72-2.25-2.55a1.52,1.52,0,0,0-.53,1.35c.36,3.46,1.8,8.8.56,9.51s-2.63,1.52-4.16-1.11c-1.32-2.29-5.11-11.13-6.07-13.39a2.17,2.17,0,0,0-.7-.89c-2.39-1.79-13.33-9.62-20.51-8.58,7.2,6.37,7.2,6.38,13.85,14.83s18.07,28.2,22.29,41.57c3.15,10,5,17.75,5.78,21.05a2.41,2.41,0,0,1-1.14,2.62l-17.6,10.18a2.4,2.4,0,0,1-3.2-.73c-4.45-6.58-19.32-28.71-21.79-34.46a1,1,0,0,0-1.43-.47l-.74.43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 60.18,
    cy: 93.32,
    r: 6.99,
    transform: "translate(-38.64 42.68) rotate(-30.05)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -48.06,
    y1: 218.81,
    x2: -16.1,
    y2: 218.81,
    gradientTransform: "translate(113.84 -113.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.12,178.73l10.53,16.4a11.24,11.24,0,0,0,8.07,4.42,15.15,15.15,0,0,0,4.35-.21,18,18,0,0,0,5.6-2.12c9.16-5.25,17.65-10.09,8.59-17.5a15,15,0,0,0-5.65-2.87c-.87-.23-1.73-.43-2.51-.61a10,10,0,0,1-6.6-4.91l-2.11-3.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.22,182.72l9,17.31a11.24,11.24,0,0,1-.19,9.2,15.15,15.15,0,0,1-2.36,3.67,18,18,0,0,1-4.63,3.8c-9.12,5.33-17.55,10.27-19.45-1.27a15,15,0,0,1,.33-6.33c.24-.87.48-1.71.73-2.48a10,10,0,0,0-1-8.17l-2.2-3.69Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ear",
    className: "cls-4",
    d: "M11.68,50.55h0a0,0,0,0,1,0,0V68.81a0,0,0,0,1,0,0h0a7.3,7.3,0,0,1-7.3-7.3V57.86a7.3,7.3,0,0,1,7.3-7.3Z",
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -28.81, 12.04)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ear-2",
    "data-name": "ear",
    className: "cls-4",
    d: "M82.77,9.43h0a0,0,0,0,1,0,0V27.69a0,0,0,0,1,0,0h0a7.3,7.3,0,0,1-7.3-7.3V16.73a7.3,7.3,0,0,1,7.3-7.3Z",
    transform: "translate(156.89 -4.99) rotate(149.95)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "_Ellipse_",
    "data-name": "<Ellipse>",
    className: "cls-5",
    cx: 43.68,
    cy: 39.58,
    r: 38.78,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -13.95, 27.19)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -51.67,
    y1: 143.38,
    x2: -1.64,
    y2: 143.38,
    gradientTransform: "translate(-2.76 -100.21) rotate(-30.05)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "astronaut_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 25.87,
    y: 78.21,
    width: 6.32,
    height: 6.32,
    rx: 3.16,
    ry: 3.16,
    transform: "translate(94.9 137.26) rotate(149.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M91.91,123.18,61.16,141a10.6,10.6,0,0,1-13.91-3l-24.38-33.9a15.5,15.5,0,0,1,4.82-22.46L57.8,64.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.69,122.79l-29.6,17.12A10.2,10.2,0,0,1,48.69,137L25.41,104.66a15.21,15.21,0,0,1,4.73-22L58.84,66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 84.16,
    y: 44.49,
    width: 6.32,
    height: 6.32,
    rx: 3.16,
    ry: 3.16,
    transform: "translate(-12.12 50.13) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M91.82,123.23l30.75-17.79a10.6,10.6,0,0,0,4.35-13.55l-17.23-38a15.5,15.5,0,0,0-21.87-7L57.71,64.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.21,123.07l29.6-17.12a10.2,10.2,0,0,0,4.19-13L108.54,56.58a15.21,15.21,0,0,0-21.47-6.89l-28.7,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.52,141l-.74.43a1,1,0,0,0-.31,1.48c3.75,5,15.52,28.93,19,36.07a2.4,2.4,0,0,1-1,3.14l-17.6,10.18a2.41,2.41,0,0,1-2.84-.31c-2.49-2.3-8.3-7.8-15.37-15.5-9.49-10.32-20.91-30.07-24.92-40s-4-10-5.95-19.4c-4.48,5.71-3.15,19.09-2.79,22.06a2.17,2.17,0,0,0,.42,1.05c1.48,2,7.26,9.65,8.58,11.94,1.52,2.63,0,4.7-1.11,4.16A86.32,86.32,0,0,1,50,151a1.52,1.52,0,0,0-1.43-.22c-1.78.7,1.08,3.23,1.08,3.23a47.17,47.17,0,0,0,5.68,3.74,3.72,3.72,0,0,1,2.05,2.61,2.31,2.31,0,0,1-.68,2.32c-3.69,3.32-9.35,1.69-12.48.38a8.71,8.71,0,0,1-4-3.3,19,19,0,0,1-3.09-9.08,18.73,18.73,0,0,0-2.7-10.74c-14.13-27.08,3.31-51.12,4.86-55.66,9-3.18,15.13-10.62,22.07-14.56l-.21.12C68.07,65.77,76.72,63.65,84,57.4c4.71.93,35.09-1.66,51.52,24.1a18.73,18.73,0,0,0,8,7.69,19,19,0,0,1,6.33,7.21,8.71,8.71,0,0,1,.89,5.07c-.43,3.36-1.84,9.08-6.55,10.62a2.31,2.31,0,0,1-2.35-.57,3.72,3.72,0,0,1-1.24-3.08,47.17,47.17,0,0,0-.41-6.79s-.76-3.72-2.25-2.55a1.52,1.52,0,0,0-.53,1.35c.36,3.46,1.8,8.8.56,9.51s-2.63,1.52-4.16-1.11c-1.32-2.29-5.11-11.13-6.07-13.39a2.17,2.17,0,0,0-.7-.89c-2.39-1.79-13.33-9.62-20.51-8.58,7.2,6.37,7.2,6.38,13.85,14.83s18.07,28.2,22.29,41.57c3.15,10,5,17.75,5.78,21.05a2.41,2.41,0,0,1-1.14,2.62l-17.6,10.18a2.4,2.4,0,0,1-3.2-.73c-4.45-6.58-19.32-28.71-21.79-34.46a1,1,0,0,0-1.43-.47l-.74.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 102.92,
    y: 60.31,
    width: 18.38,
    height: 7.44,
    transform: "translate(8.96 141.66) rotate(-66.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M84,57.4s33.5,5.64,47.74,20.34c11.5,16.28,9.9,9.91,11.65,12s9,4.71,4.3,19.15,12.71-8.66,12.71-8.66L136.73,63.89,86.92,52.57l-2.39,4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 19.21,
    y: 108.48,
    width: 18.95,
    height: 7.67,
    transform: "translate(8.25 -1.79) rotate(4.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 106.09,
    y: 142.05,
    width: 40.01,
    height: 3.26,
    transform: "translate(-61.47 106.77) rotate(-37.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 71.28,
    y: 162.08,
    width: 40.01,
    height: 3.26,
    transform: "translate(-55.7 47.4) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M130.51,94.6S116,82.14,99.61,81.72c0,0,22.44,19.86,28.56,34,3.22,6.48,22.61,42.7,20.27,54C159.9,158.92,130.51,94.6,130.51,94.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.44,152.34s-13.54-34.22-13-45c-6,14.92-8.56,22.15-4.8,34.05,9.18,11.37,15.76,16.43,15.76,16.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M101.66,141.53l-3.86,2.23a1.1,1.1,0,0,0-.35,1.59c3.05,4.32,15.42,22.14,23.57,38.92a1.1,1.1,0,0,0,1.86.21,7.9,7.9,0,0,0,1.68-5.34,1.09,1.09,0,0,0-.15-.47l-21.25-36.73A1.1,1.1,0,0,0,101.66,141.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M38.6,92.51c-7.44,10.56-7.1,22.87-7.14,25.5a55.92,55.92,0,0,0,2.44,16.83c3.39,5.86,4.46,10.41,4,11.47s-6,5.84-6,5.84l-15.59-27,1.65-26L38.67,83.61Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 60.18,
    cy: 93.32,
    r: 6.99,
    transform: "translate(-38.64 42.68) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M63.92,88.92,60.67,90.8l.27-6.48-3.79,2.19.56,9.16,2.8-1.62,1,8.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M63.3,88.76l-3.25,1.88.27-6.48-3.79,2.19.56,9.16,2.8-1.62,1,8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.94,113.17,77.79,128.63a6,6,0,0,1-8.27-2.12L63.28,116a6,6,0,0,1,2.12-8.27L91.56,92.22a6,6,0,0,1,8.27,2.12l6.24,10.55A6,6,0,0,1,103.94,113.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 70.63,
    y: 115.12,
    width: 12.88,
    height: 2.39,
    rx: 1.19,
    ry: 1.19,
    transform: "translate(-48.47 55.42) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 80.97,
    cy: 114,
    r: 0.95,
    transform: "translate(-46.75 57.08) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 72.33,
    y: 117.99,
    width: 12.88,
    height: 2.39,
    rx: 1.19,
    ry: 1.19,
    transform: "translate(-49.7 56.68) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 76.1,
    cy: 120.76,
    r: 0.95,
    transform: "translate(-50.87 55.55) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 74.03,
    y: 120.87,
    width: 12.88,
    height: 2.39,
    rx: 1.19,
    ry: 1.19,
    transform: "translate(-50.92 57.95) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 81.91,
    cy: 121.21,
    r: 0.95,
    transform: "translate(-50.29 58.56) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 87.9,
    y: 105.17,
    width: 11.45,
    height: 0.48,
    transform: "translate(-40.62 62.33) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.3,
    y: 105.84,
    width: 11.45,
    height: 0.48,
    transform: "translate(-40.9 62.62) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.7,
    y: 106.52,
    width: 11.45,
    height: 0.48,
    transform: "translate(-41.19 62.92) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 89.09,
    y: 107.19,
    width: 11.45,
    height: 0.48,
    transform: "matrix(0.86, -0.51, 0.51, 0.86, -41.48, 63.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 89.49,
    y: 107.86,
    width: 11.45,
    height: 0.48,
    transform: "translate(-41.76 63.51) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 89.89,
    y: 108.53,
    width: 11.45,
    height: 0.48,
    transform: "translate(-42.05 63.81) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.29,
    y: 109.2,
    width: 11.45,
    height: 0.48,
    transform: "matrix(0.86, -0.51, 0.51, 0.86, -42.34, 64.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 90.68,
    y: 109.88,
    width: 11.45,
    height: 0.48,
    transform: "matrix(0.86, -0.51, 0.51, 0.86, -42.62, 64.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 91.08,
    y: 110.55,
    width: 11.45,
    height: 0.48,
    transform: "matrix(0.86, -0.51, 0.51, 0.86, -42.91, 64.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 91.48,
    y: 111.22,
    width: 11.45,
    height: 0.48,
    transform: "matrix(0.86, -0.51, 0.51, 0.86, -43.2, 64.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 91.88,
    y: 111.89,
    width: 11.45,
    height: 0.48,
    transform: "translate(-43.48 65.29) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 92.27,
    y: 112.56,
    width: 11.45,
    height: 0.48,
    transform: "translate(-43.77 65.58) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 65.78,
    y: 102.87,
    width: 31.97,
    height: 5.25,
    rx: 2.62,
    ry: 2.62,
    transform: "translate(-42.31 56.3) rotate(-30.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 124.79,
    y: 90.51,
    width: 18.95,
    height: 3.16,
    transform: "translate(-28.49 87.87) rotate(-32.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 34.4,
    y: 142.43,
    width: 18.95,
    height: 3.16,
    transform: "translate(-57.43 32.65) rotate(-25.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 60.23,
    y: 130.11,
    width: 75.35,
    height: 6.32,
    transform: "translate(-53.66 67.13) rotate(-30.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 91.39,
    y: 129.1,
    width: 12.63,
    height: 8.57,
    rx: 1.32,
    ry: 1.32,
    transform: "translate(-53.74 67.05) rotate(-30.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 97.71,
    cy: 133.38,
    r: 2.93,
    transform: "translate(-53.74 67.05) rotate(-30.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.12,178.73l10.53,16.4a11.24,11.24,0,0,0,8.07,4.42,15.15,15.15,0,0,0,4.35-.21,18,18,0,0,0,5.6-2.12c9.16-5.25,17.65-10.09,8.59-17.5a15,15,0,0,0-5.65-2.87c-.87-.23-1.73-.43-2.51-.61a10,10,0,0,1-6.6-4.91l-2.11-3.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 158.17,
    cy: 175.3,
    r: 5.64,
    transform: "translate(-66.52 102.76) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M130.73,197.69l6.5-5.85a11.24,11.24,0,0,0,8.07,4.42,15.15,15.15,0,0,0,4.35-.21,18,18,0,0,0,5.6-2.12c9.16-5.25,17.65-10.09,8.59-17.5a15,15,0,0,0-5.65-2.87c-.87-.23-1.73-.43-2.51-.61-2.8-.61,16.27.54,14.86-2l7.11,10.48L173.79,191l-10,8.9-11.22,4.93-7,.43-6.39-2-4.44-3.17Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 125.42,
    y: 168.94,
    width: 26.62,
    height: 4.96,
    rx: 2.48,
    ry: 2.48,
    transform: "translate(344.65 250.35) rotate(149.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 139.14,
    y: 179.19,
    width: 1.11,
    height: 9.93,
    transform: "translate(-73.44 94.7) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 144.13,
    y: 176.31,
    width: 1.11,
    height: 9.93,
    transform: "translate(-71.32 96.81) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 141.64,
    y: 177.75,
    width: 1.11,
    height: 9.93,
    transform: "translate(-72.38 95.76) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.22,182.72l9,17.31a11.24,11.24,0,0,1-.19,9.2,15.15,15.15,0,0,1-2.36,3.67,18,18,0,0,1-4.63,3.8c-9.12,5.33-17.55,10.27-19.45-1.27a15,15,0,0,1,.33-6.33c.24-.87.48-1.71.73-2.48a10,10,0,0,0-1-8.17l-2.2-3.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 104.77,
    cy: 206.19,
    r: 5.64,
    transform: "translate(-89.16 80.17) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M137.86,193.56l-8.31,2.72a11.24,11.24,0,0,1-.19,9.2,15.15,15.15,0,0,1-2.36,3.67,18,18,0,0,1-4.63,3.8c-9.12,5.33-17.55,10.27-19.45-1.27a15,15,0,0,1,.33-6.33c.24-.87.48-1.71.73-2.48.87-2.73-7.64,14.37-9.11,11.91l5.55,11.39,10.19,1.4,12.68-4.21,9.87-7.27,3.89-5.9,1.42-6.56-.53-5.43Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 97.79,
    y: 184.92,
    width: 26.62,
    height: 4.96,
    rx: 2.48,
    ry: 2.48,
    transform: "translate(-78.91 80.82) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 121.1,
    y: 189.63,
    width: 1.11,
    height: 9.93,
    transform: "translate(324.4 302.12) rotate(149.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 116.11,
    y: 192.52,
    width: 1.11,
    height: 9.93,
    transform: "translate(316.54 310) rotate(149.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 118.61,
    y: 191.07,
    width: 1.11,
    height: 9.93,
    transform: "matrix(-0.87, 0.5, -0.5, -0.87, 320.47, 306.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.21,
    y: 62.39,
    width: 5.87,
    height: 0.72,
    transform: "translate(36.49 115.71) rotate(149.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ear-3",
    "data-name": "ear",
    className: "cls-4",
    d: "M11.68,50.55h0a0,0,0,0,1,0,0V68.81a0,0,0,0,1,0,0h0a7.3,7.3,0,0,1-7.3-7.3V57.86a7.3,7.3,0,0,1,7.3-7.3Z",
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -28.81, 12.04)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle",
    className: "cls-23",
    cx: 34.63,
    cy: 43.98,
    rx: 29.49,
    ry: 31.36,
    transform: "translate(-11.99 13) rotate(-18.18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 4.89,
    cy: 61.55,
    rx: 0.9,
    ry: 1.8,
    transform: "translate(-30.16 10.72) rotate(-30.05)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 81.49,
    y: 15.13,
    width: 5.87,
    height: 0.72,
    transform: "translate(3.59 44.35) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ear-4",
    "data-name": "ear",
    className: "cls-4",
    d: "M82.77,9.43h0a0,0,0,0,1,0,0V27.69a0,0,0,0,1,0,0h0a7.3,7.3,0,0,1-7.3-7.3V16.73a7.3,7.3,0,0,1,7.3-7.3Z",
    transform: "translate(156.89 -4.99) rotate(149.95)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    className: "cls-23",
    cx: 52.87,
    cy: 34.43,
    rx: 29.25,
    ry: 31.04,
    transform: "translate(-10.13 31.1) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 82.25,
    cy: 16.69,
    rx: 0.9,
    ry: 1.8,
    transform: "translate(2.7 43.43) rotate(-30.05)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "_Ellipse_2",
    "data-name": "<Ellipse>",
    className: "cls-5",
    cx: 43.68,
    cy: 39.58,
    r: 38.78,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -13.95, 27.19)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Ellipse_3",
    "data-name": "<Ellipse>",
    className: "cls-1",
    cx: 45.72,
    cy: 38.4,
    rx: 36.63,
    ry: 38.78,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -13.08, 28.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "_Ellipse_4",
    "data-name": "<Ellipse>",
    className: "cls-26",
    cx: 45.71,
    cy: 38.24,
    rx: 36.55,
    ry: 38.78,
    transform: "translate(-13 28.03) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "_Ellipse_5",
    "data-name": "<Ellipse>",
    className: "cls-1",
    cx: 44.35,
    cy: 39.03,
    rx: 34.97,
    ry: 38.78,
    transform: "translate(-13.58 27.45) rotate(-30.05)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "purple",
    className: "cls-27",
    d: "M68,25.49c7.78,13.45,3.6,29.1-9.85,36.88S27.1,67.12,19.32,53.67s-1.63-30.24,11.82-38S60.25,12,68,25.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "purple-2",
    "data-name": "purple",
    className: "cls-28",
    d: "M67.61,24.72c7.53,13,4.26,27.7-7.7,34.62a26.11,26.11,0,0,1-26.15-45.2C45.72,7.22,60.08,11.71,67.61,24.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M45.16,11.75c9.13,0,17.72,4.84,22.87,13.74,7.78,13.45,3.6,29.1-9.85,36.88a31.21,31.21,0,0,1-15.59,4.22c-9.34,0-18.31-4.34-23.27-12.92-7.78-13.45-1.63-30.24,11.82-38a27.93,27.93,0,0,1,14-3.89m0-5v0h0a33.11,33.11,0,0,0-16.51,4.57C12.29,20.78,6.16,40.9,15,56.17c5.58,9.65,15.9,15.42,27.6,15.42A36.19,36.19,0,0,0,60.68,66.7,32,32,0,0,0,75.9,47.35,32,32,0,0,0,72.36,23c-5.88-10.17-16-16.24-27.2-16.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.09,66.57h44.2A7.68,7.68,0,0,1,92,74.25V76a0,0,0,0,1,0,0H32.41a0,0,0,0,1,0,0V74.25A7.68,7.68,0,0,1,40.09,66.57Z",
    transform: "translate(-27.35 40.72) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M35.38,65.4H87.65A3.65,3.65,0,0,1,91.29,69v5.83a0,0,0,0,1,0,0H31.73a0,0,0,0,1,0,0V69A3.65,3.65,0,0,1,35.38,65.4Z",
    transform: "translate(-26.85 40.23) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 40.69,
    cy: 82.44,
    r: 2.26,
    transform: "translate(-35.81 31.45) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 47.66,
    cy: 78.41,
    r: 2.26,
    transform: "translate(-32.86 34.4) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 54.62,
    cy: 74.38,
    r: 2.26,
    transform: "translate(-29.9 37.35) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 61.59,
    cy: 70.35,
    r: 2.26,
    transform: "translate(-26.95 40.29) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 68.55,
    cy: 66.32,
    r: 2.26,
    transform: "translate(-24 43.24) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 75.52,
    cy: 62.29,
    r: 2.26,
    transform: "translate(-21.04 46.19) rotate(-30.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 82.48,
    cy: 58.26,
    r: 2.26,
    transform: "translate(-18.09 49.13) rotate(-30.05)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.e2b60a65821122a3377a8f0f01d68285.svg";
export { ForwardRef as ReactComponent };